<header class="d-print-none">
  <backstage-site-header wide="true" active="search"></backstage-site-header>
</header>
<main>
  <backstage-notifications [connect]="true"/>
  @if ('community' | hasRole) {
    <backstage-feedback-popup/>
  }
  <router-outlet/>
</main>
<footer class="d-print-none">
  <backstage-site-footer wide="true"></backstage-site-footer>
</footer>
